import { Grid } from "@mui/material";
import { apiClient } from "api/apiClient";
import Download from "assets/download.svg";
import Phone from "assets/phone.svg";
import ButtonArrow from "assets/rightPath.svg";
import ButtonArrowWhite from "assets/rightpathWhite.png";
import Wheel from "assets/wheel";
import { useLanguage } from "LanguageContext";
import Broucher from "Pages/components/Broucher";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactMarkdown from "react-markdown";
import Box from "ReusableComponents/Box";
import Button from "ReusableComponents/Button";
import Text from "ReusableComponents/Text";
import H2 from "ReusableComponents/Text/H2";
import Span from "ReusableComponents/Text/Span";
import { COLORS, SIZES } from "theme";

const BottomContentLr = ({ small, medium, isHiload, isLR }) => {
  const [hover, setHover] = useState(false);
  const [hover1, setHover1] = useState(false);
  const [hover2, setHover2] = useState(false);
  const [open, setOpen] = useState(false);
  const [bottomContent, setBottomContent] = useState({});
  const [showFullDescription, setShowFullDescription] = useState(false);

  const { selectedLanguage } = useLanguage();
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  useEffect(() => {
    if (isHiload) {
      apiClient.getBottomContentHiload(selectedLanguage).then((res) => {
        setBottomContent(res.data.attributes);
      });
    } else if (isLR) {
      apiClient.getBottomContentLR(selectedLanguage).then((res) => {
        setBottomContent(res.data.attributes);
      });
    } else {
      apiClient.getBottomContent(selectedLanguage).then((res) => {
        setBottomContent(res.data.attributes);
      });
    }
  }, [selectedLanguage]);

  const toggleDescription = () => {
    setShowFullDescription((prev) => {
      // Scroll back to the section if collapsing the description
      if (prev) {
        sectionRef.current?.scrollIntoView({ behavior: "smooth" });
      }
      return !prev;
    });
  };

  // Function to truncate markdown content
  const truncateMarkdown = (markdown, maxLength) => {
    if (markdown.length <= maxLength) return markdown;
    return markdown.substr(0, markdown.lastIndexOf(" ", maxLength)) + "...";
  };

  return (
    <Grid
      container
      spacing={2}
      ref={sectionRef}
      sx={{ padding: small ? SIZES.forty : "80px" }}
    >
      <Grid item xs={12} md={6}>
        <Box display="flex" flexDirection="column">
          <h3
            fontSize={small ? SIZES.twentyFour : "48px"}
            fontWeight={"bolder"}
            margin={0}
            display="flex"
            flexDirection="column"
          >
            <Span
              fontSize={small ? SIZES.twentyFour : SIZES.forty}
              w="fit-content"
              textAlign="center"
              textColor={COLORS.black}
              fontWeight="bold"
            >
              {bottomContent?.title}
            </Span>
            {small && (
              <Grid
                item
                xs={12}
                md={6}
                style={{
                  marginTop: small && "20px",
                }}
              >
                <img
                  src={bottomContent?.image?.data?.attributes?.url}
                  alt="cta"
                  style={{
                    height: small || medium ? "100%" : "420px",
                    width: small && "100%",
                  }}
                />
              </Grid>
            )}
            {/* Description with ReactMarkdown and See More / See Less functionality */}
            <Box
              w="fit-content"
              padding={small ? "0px 0px" : "20px 0px"}
              color="#1C1C1C"
              marginRight={small ? "0px" : "50px"}
            >
              <Span
                fontSize={small ? SIZES.twelve : SIZES.sizteen}
                w="fit-content"
                textColor="#1C1C1C"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "flex-end",
                }}
              >
                <ReactMarkdown>
                  {showFullDescription
                    ? bottomContent?.description
                    : truncateMarkdown(bottomContent?.description || "", 200)}
                </ReactMarkdown>
                <button
                  onClick={toggleDescription}
                  style={{
                    backgroundColor: "transparent",
                    color: COLORS.primary,
                    fontFamily: "Archia",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    fontSize: "14px",
                    marginLeft: showFullDescription ? "4px" : "0px",
                    marginBottom: small ? "10px" : "16px",
                  }}
                >
                  {showFullDescription ? t("See Less") : t("See More")}
                </button>
              </Span>
            </Box>
          </h3>

          <Button
            isHover={true}
            display="flex"
            cursor="pointer"
            w={small || medium ? "100%" : "450px"}
            justifyContent="center"
            marginTop={small ? SIZES.forty : SIZES.twenty}
            alignItems="center"
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            background={hover ? COLORS.black : COLORS.primary}
            onClick={() =>
              (window.location.href = `/${selectedLanguage}/test-ride`)
            }
            padding={small ? "16px" : "20px"}
          >
            <Wheel fill={hover ? COLORS.white : COLORS.black} />
            <Text
              fontWeight="bold"
              fontSize="15px"
              textColor={hover ? COLORS.white : COLORS.black}
              margin={"0 8px"}
            >
              {t("Book a Test Ride")}
            </Text>
            <img
              src={hover ? ButtonArrowWhite : ButtonArrow}
              alt="arrow"
              style={{ margin: "0 8px" }}
              height={SIZES.sizteen}
            />
          </Button>
          <a href="tel:1800 1238 1238">
            <Box
              border={COLORS.primary}
              display="flex"
              cursor="pointer"
              w={small || medium ? "100%" : "450px"}
              justifyContent="center"
              marginTop="24px"
              alignItems="center"
              b="1px solid #99CEFB"
              onMouseEnter={() => setHover1(true)}
              hoverBackground={true}
              onMouseLeave={() => setHover1(false)}
              backgroundColor={hover1 ? COLORS.primary : COLORS.white}
              padding={"0 20px"}
            >
              <img
                src={Phone}
                alt="phone"
                style={{ margin: "0 8px" }}
                height={"21px"}
              />

              <Text fontWeight="bold" fontSize="15px" textColor={COLORS.black}>
                {t("Call Us 1800 1238 1238")}
              </Text>
            </Box>
          </a>
          <Box
            display="flex"
            cursor="pointer"
            alignItems="center"
            w={small || medium ? "100%" : "450px"}
            justifyContent="center"
            marginTop="24px"
            b="1px solid #99CEFB"
            hoverBackground={true}
            onMouseEnter={() => setHover2(true)}
            onMouseLeave={() => setHover2(false)}
            background={hover2 ? COLORS.primary : COLORS.white}
            onClick={() => {
              setOpen(true);
            }}
            padding={"0 20px"}
          >
            <img
              src={Download}
              alt="download"
              style={{ margin: "0 8px" }}
              height={"21px"}
            />

            <Text fontWeight="bold" fontSize="15px" textColor={COLORS.black}>
              {t("Download Brochure")}
            </Text>
          </Box>
        </Box>
      </Grid>
      {!small && (
        <Grid item xs={12} md={6} style={{ marginTop: small && "20px" }}>
          <img
            src={bottomContent?.image?.data?.attributes?.url}
            alt="Euler StromEV Deck"
            style={{
              height: small || medium ? "100%" : "420px",
              width: small && "100%",
            }}
          />
        </Grid>
      )}

      {open && (
        <Broucher
          open={open}
          handleClose={() => setOpen(false)}
          small={small}
        />
      )}
    </Grid>
  );
};

export default BottomContentLr;
